

import { Vue, Component, Prop } from 'vue-property-decorator'
import { IProduct } from '~/interfaces/product'
import BlockHeader from '~/components/shared/block-header.vue'
import SaleCard from '~/components/shared/sale-card.vue'

type BlockSaleLayout = 'large-first' | 'large-last';

@Component({
    components: { BlockHeader, SaleCard }
})
export default class BlockSale extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string
    @Prop({ type: String }) readonly desc!: string
    @Prop({ type: String, default: () => 'large-first' }) readonly layout!: BlockSaleLayout
    @Prop({ type: Object, default: () => undefined }) readonly featuredProduct!: IProduct
    @Prop({ type: Array, default: () => [] }) readonly products!: IProduct[]
}

